import type { StackProps } from '@mui/material';
import { Stack } from '@mui/material';

type PpTextWithIcon = Pick<StackProps, 'sx'> & {
  children: React.ReactNode;
};

export function TextWithIcon({ children, sx }: PpTextWithIcon): React.ReactElement {
  return (
    <Stack alignItems="center" direction="row" spacing={0.5} sx={sx}>
      {children}
    </Stack>
  );
}
